module.exports = __webpack_public_path__ + "static/washington-dc-line-drawing-61a6280c918546a4fa7e0afa34fca5ab.svg";